import React from 'react'
import AboutPostHeader from '../ContactUs/AboutPostHeader'
import Footer from '../LandingPage/Footer'
import Header from '../LandingPage/Header'
import Navbar from '../LandingPage/Navbar'
import Box from './Box'

const mobileDevService = () => {
    const data = [
        {
          font: <i class="fas fa-3x awesome-hover fa-mobile-alt text-primary"></i>,
          head: "Custom Android App Development",
        },
        {
            font: <i class="fas fa-3x awesome-hover text-primary fa-gamepad"></i>,
            head: "Android Game Development",
          },
          {
            font: <i class="fas fa-3x awesome-hover text-primary fa-share-alt"></i>,
            head: "Social Media Android App Development",
          },
          {
            font: <i class="fas fa-3x awesome-hover text-primary fa-door-closed"></i>,
            head: "Enterprise Android App Development",
          },
          {
            font: <i class="fas fa-3x awesome-hover text-primary fa-th-large"></i>,
            head: "Android Widget Development",
          },
          {
            font: <i class="fas fa-3x awesome-hover text-primary fa-check-circle"></i>,
            head: "Android App Testing and Portability",
          }, 
          {
            font: <i class="fas fa-3x awesome-hover text-primary fa-th-large"></i>,
            head: "Android App Maintainance",
          },
          {
            font: <i class="fas fa-3x awesome-hover text-primary fa-users"></i>,
            head: "Android App Support",
          },    

      ]
      var techArray = data.map((section) => {
        return (
          <Box
            font={section.font}
            head={section.head}
          />
        )
      })
      const contact = {
        head: " Android App Development",
      };
    return (
        <div>
            <Header />
            <Navbar />
<AboutPostHeader obj={contact} />
            <div className="container mt-5">
    <p className="text-justify">Our dedicated team of expert android app developers has the necessary experience and expertise in Android app development that ensures high-performance and excellence. Harnessing the maximum potential of the Android platform, we work on offering unlimited possibilities to our customers with our highly scalable and robust android mobile applications.</p>
          <div className="row">
     {techArray}
   
          </div>
            </div>
            <Footer />
        </div>
    )
}

export default mobileDevService
